import React from "react";
import { Link } from "react-router-dom";
import { SERVICE_AREAS } from "@/lib/api";
import { MapPin, Phone, ArrowRight } from "lucide-react";

const Locations = () => (
  <div data-testid="locations-page">
    <section className="border-b border-border bg-muted">
      <div className="container-wide py-16 lg:py-20">
        <p className="kicker">Locations</p>
        <h1 className="mt-3 font-display text-4xl font-black sm:text-5xl lg:text-6xl">
          Serving Wesley Chapel &amp; surrounding rural areas.
        </h1>
        <p className="mt-4 max-w-2xl text-lg text-muted-foreground">
          We coordinate junk removal and trash hauling with vetted local crews across Pasco, Hillsborough,
          and Hernando counties. Don&apos;t see your town? Submit a free quote — chances are we cover it.
        </p>
        <div className="mt-6 flex flex-wrap gap-3">
          <Link to="/contact" className="btn-cta" data-testid="locations-quote-cta">
            Get a Free Quote <ArrowRight className="h-4 w-4" />
          </Link>
          <a href="tel:+18135550100" className="btn-ghost" data-testid="locations-call-cta">
            <Phone className="h-4 w-4" /> Call Dispatch
          </a>
        </div>
      </div>
    </section>

    <section className="section">
      <div className="container-wide">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICE_AREAS.map((a) => (
            <Link
              key={a.slug}
              to={`/service-areas/${a.slug}`}
              className="group flex items-start gap-3 rounded-sm border border-border bg-card p-5 transition-colors hover:border-primary"
              data-testid={`location-${a.slug}`}
            >
              <MapPin className="mt-0.5 h-5 w-5 flex-shrink-0 text-primary" />
              <div className="flex-1">
                <p className="font-display font-bold group-hover:text-primary">
                  {a.name}, FL
                  {a.featured && <span className="ml-2 rounded-sm bg-primary/15 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-primary">Home base</span>}
                </p>
                <p className="text-xs text-muted-foreground">{a.county}</p>
                <p className="mt-2 text-xs text-foreground/60 group-hover:text-foreground/80">
                  Junk removal, yard debris, bulk pickup &amp; more →
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-16 rounded-sm border border-border bg-card p-8">
          <p className="kicker">Not in this list?</p>
          <h2 className="mt-2 font-display text-2xl font-black sm:text-3xl">We&apos;re expanding — send a quote request.</h2>
          <p className="mt-3 max-w-2xl text-muted-foreground">
            We&apos;re actively adding partner haulers across Central and North Florida. Submit your ZIP and we&apos;ll
            let you know if we can cover you today, or add you to the waitlist so you&apos;re first when we do.
          </p>
          <Link to="/contact" className="btn-cta mt-6" data-testid="locations-waitlist-cta">
            Check My Area <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  </div>
);

export default Locations;
